import React, { useState } from "react";
import { CAR_MAKES } from "../../utils/carMakes";

// Champ "Marque du véhicule" — même idiome que VenueField (texte libre + suggestions filtrées en
// recouvrement, jamais un choix fermé : une marque absente de la liste reste saisissable). Le
// recouvrement (position:absolute) évite exactement le bug corrigé sur VenueField — un contenu
// qui "se balade" en poussant tout ce qui suit vers le bas à chaque frappe.
export default function CarMakeField({ value, onChange, placeholder }: { value: string; onChange: (v: string) => void; placeholder?: string }) {
  const [open, setOpen] = useState(false);
  const filtered = value.trim()
    ? CAR_MAKES.filter(m => m.toLowerCase().includes(value.trim().toLowerCase())).slice(0, 8)
    : CAR_MAKES.slice(0, 8);

  return (
    <div style={{ position: "relative" }}>
      <input
        value={value}
        onChange={e => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        maxLength={60}
        style={{ width: "100%", padding: "11px 14px", borderRadius: 10, border: "1px solid #E0E0E0", backgroundColor: "#F8F8F8", fontSize: 14, outline: "none", marginBottom: 4, boxSizing: "border-box" }}
      />
      {open && filtered.length > 0 && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 199 }} />
          <div style={{ position: "absolute", top: "100%", left: 0, right: 0, backgroundColor: "white", border: "1px solid #E0E0E0", borderRadius: 10, zIndex: 200, boxShadow: "0 4px 20px rgba(0,0,0,0.1)", maxHeight: 240, overflowY: "auto" }}>
            {filtered.map(make => (
              <div key={make} onClick={() => { onChange(make); setOpen(false); }} style={{ padding: "10px 14px", cursor: "pointer", fontSize: 14 }}>
                {make}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
